import { useContextOrThrow } from '@deephaven/react-hooks';
import { ServerConfigContext } from "./ServerConfigBootstrap.js";
export function useServerConfig() {
  return useContextOrThrow(ServerConfigContext, 'No server config available in useServerConfig. Was code wrapped in ServerConfigBootstrap or ServerConfigContext.Provider?');
}
export default useServerConfig;
//# sourceMappingURL=useServerConfig.js.map